import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class PerformanceMaxImportToDoColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    const title = newI18n.getString(_TL_('What you can do'));
    super({
      name: 'performanceMaxImportToDo',
      property: 'PerformanceMaxImportToDo',
      title,
      bodyClasses: ['grid-column-performance-max-import-todo'],
      colClasses: ['col-superLongText'],
      type: 'string',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  template() {
    return this.newI18n.getString(_TL_('Once set up is complete, please review your import to make sure everything looks correct.'));
  }
}
